/**
 * BadgeFab — Fully assembled Badge.
 *
 * Pass label, variant, size — colors resolved internally.
 * For full control, use the primitive Badge + BadgeText instead.
 */
import type { GetProps } from 'tamagui'
import { Badge, BadgeText } from '../elements/Badge'

const TEXT_COLOR: Record<string, string> = {
  default: '$colorInverse',
  success: '$colorInverse',
  warning: '$colorInverse',
  error: '$colorInverse',
  info: '$colorInverse',
  muted: '$colorSecondary',
}

type BadgeFrameProps = GetProps<typeof Badge>

interface BadgeFabProps extends Omit<BadgeFrameProps, 'children'> {
  label: string
}

export function BadgeFab({
  label,
  variant = 'default',
  size = 'md',
  ...props
}: BadgeFabProps) {
  const textColor = TEXT_COLOR[variant] ?? '$colorInverse'

  return (
    <Badge variant={variant} size={size} {...props}>
      <BadgeText color={textColor} size={size}>{label}</BadgeText>
    </Badge>
  )
}
